import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { userDefinedFunctions } from 'utils/urlConstants';


export const useFetchCrQuestionUdf = (crId, crqId) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useQuery(
    ['crQuestionUdf', orgId],
    async () => {
      const { data } = await axiosInstance.get(userDefinedFunctions(orgId)
        .crQuestionUdf(crId, crqId));
      return data;
    },
    {
      enabled: !!crqId,
      onError: (err) => {
        dispatch(showAlert({
          message: err.response?.data?.message ?? 'Error fetching cleanroom question UDFs',
          type: 'error',
        }));
      },
    },
  );
};
